import { c as _c } from "react/compiler-runtime";
import React, { memo } from 'react';
import classNames from 'classnames';
import RatioContainer from 'components/consumer/RatioContainer';
const MaterialThumbnailWrapper = t0 => {
  const $ = _c(9);
  const {
    children,
    hasClickHandler,
    fullHeightThumbnail,
    variant
  } = t0;
  let t1;
  if ($[0] !== hasClickHandler) {
    t1 = classNames("MaterialThumbnailUI__wrapper", {
      "hover:cursor-pointer": hasClickHandler
    });
    $[0] = hasClickHandler;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = variant === "PDPCustomerPhotosReviewsModal";
  let t3;
  if ($[2] !== fullHeightThumbnail || $[3] !== t2) {
    t3 = classNames("MaterialThumbnailUI__outer-wrapper", {
      "h-full": fullHeightThumbnail,
      "!pt-0 h-[59px]": t2
    });
    $[2] = fullHeightThumbnail;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== children || $[6] !== t1 || $[7] !== t3) {
    t4 = <RatioContainer ratio={1} className={t1} wrapperClassName={t3}>{children}</RatioContainer>;
    $[5] = children;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default memo(MaterialThumbnailWrapper);